export enum ELeaderboardType {
    MOST_DEMOS = 'MOST_DEMOS',
    MOST_VISITS = 'MOST_VISITS',
    MOST_PROPOSALS = 'MOST_PROPOSALS',
    MOST_CONVERTED = 'MOST_CONVERTED',
}
